import { spaceClient } from './client';

export const getPredefinedComments = () =>
  spaceClient.get('/cms/predefined-comments', { params: { includeInactive: 'true' } }).then((r) => r.data);

export const createPredefinedComments = (payload) =>
  spaceClient.post('/predefined-comments', payload).then((r) => r.data);

export const deletePredefinedComments = (id) =>
  spaceClient.delete(`/predefined-comments/${id}`).then((r) => r.data);

export const updatePredefinedComments = (id, payload) =>
  spaceClient.put(`/predefined-comments/${id}`, payload).then((r) => r.data);
